import { render, staticRenderFns } from "./ModalPriceStudentRange.vue?vue&type=template&id=0c80166e&"
import script from "./ModalPriceStudentRange.vue?vue&type=script&lang=js&"
export * from "./ModalPriceStudentRange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports